/**
 * AngularJS Tutorial 1
 * @author Nick Kaye <nick.c.kaye@gmail.com>
 */

/**
 * Main AngularJS Web Application
 */
var app = angular.module('tutorialWebApp', [
  'ngRoute'
]);

/**
 * Configure the Routes
 */
app.config(['$routeProvider', function ($routeProvider) {
  $routeProvider
    // Home
    .when("/", {templateUrl: "partials/contact.html", controller: "PageCtrl"})
    // Pages
    .when("/faq", {templateUrl: "partials/faq.html", controller: "PageCtrl"})
    .when("/pricing", {templateUrl: "partials/pricing.html", controller: "PageCtrl"})
    .when("/services", {templateUrl: "partials/services.html", controller: "PageCtrl"})
    .when("/contact", {templateUrl: "partials/contact.html", controller: "PageCtrl"})
    // Blog
    .when("/blog", {templateUrl: "partials/blog.html", controller: "BlogCtrl"})
    .when("/blog/post", {templateUrl: "partials/blog_item.html", controller: "BlogCtrl"})
    // else 404
    .otherwise("/404", {templateUrl: "partials/404.html", controller: "PageCtrl"});
}]);

/**
 * Controls the Blog
 */
app.controller('BlogCtrl', function (/* $scope, $location, $http */) {
  console.log("Blog Controller reporting for duty.");
});

/**
 * Controls all other Pages
 */
app.controller('PageCtrl', function ($log) {
  console.log("Page Controller reporting for duty.");
  $('.btn-primary').addClass('fa fa-bug');
    this.submit = function() {
        $log.info('Yep, I can log');
        $log.makeAnError();
    }
});

// add the logger and embed it into the app
var logger = new RC.Logger({
    applicationId           : 'c31c335ef37283c451b18ba0dd317de1',
    recordUserActions       : true,
    recordSessionVideo      : true,
    maxNbrOfReportedErrors  : 1,
    logResourceLoadFailures : true,
    logAjaxRequests         : true,
    captureScreenshot       : true,
    showNotificationOnError : true,
    user                    : {
        name   : 'Dan Anderson',
        email  : 'demouser@therootcause.io',
        imgUrl : 'https://s.gravatar.com/avatar/0b9e04aed9dcc2d3a121522147dfc7fa?s=80'
    }
});

app.config(function($provide) {
  $provide.decorator('$exceptionHandler', ['$log', '$delegate',
    function($log, $delegate) {
      return function(exception, cause) {
        logger.logException(exception, {
          data: { cause: cause }
        });
        $delegate(exception, cause);
      };
    }
  ]);
});
